const getRaw = (
  result: Record<string, { raw: string | boolean }>,
  value: string | number
) => {
  if (
    !result[value] ||
    result[value].raw === undefined ||
    result[value].raw === null
  ) {
    return;
  }

  // Return bools as strings
  return `${result[value].raw}`;
};

export default getRaw;
